<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <b-card>
      <form action="">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <label class="col-form-label col-form-label-sm" for="voucher_no">Voucher No</label>
            <input v-model="search_data.voucher_no" type="text" class="form-control form-control-sm" placeholder="Search by voucher no." id="voucher_no"/>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <label class="col-form-label col-form-label-sm" for="ep_id">EP ID</label>
            <input v-model="search_data.ep_id" type="text" class="form-control form-control-sm" placeholder="Search by EP ID" id="ep_id"/>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
            <select v-model="search_data.mouza_id" class="form-control form-control-sm" name="mouza_id" id="mouza_id">
              <option selected :value="''">Select a mouza</option>
              <option v-for="(mouza, index) in all_mouzas" :key="index" :value="mouza.id">{{ mouza.id }} : {{ mouza.mouza_desc }}</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <label class="col-form-label col-form-label-sm" for="ep_type">Ep Type</label>
            <select v-model="search_data.ep_type" class="form-control form-control-sm" name="ep_type" id="ep_type">
              <option selected :value="''">Select a EP Type</option>
              <option value="1">Titled</option>
              <option value="2">Non-titled</option>
            </select>
          </div>
        </div>
        <button class="btn btn-success btn-sm mt-2"  @click.prevent="getVoucherInfos()">Search</button>
      </form>
    </b-card>
    <div class="scrollable-table">
      <table class="table table-centered table-striped">
        <thead>
        <tr>
          <th>SL</th>
          <th>EP ID</th>
          <th>EP Name</th>
          <th>Voucher Number</th>
          <th>Cheque No.</th>
          <th>Cheque Date</th>
          <th>EP`s Bank Name</th>
          <th>Account No</th>
          <th>Voucher Amount(BDT)</th>
          <th>Paid EP As</th>
          <th>JVC No (JVC Date)</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(voucher_info, index) in voucher_infos" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ epIdWithPaymentStatus(voucher_info.ep_id, voucher_info.is_paid) }}</td>
          <td>
            <router-link :to="{ name: 'sesView',params: { ses_id: voucher_info.ses_id }}" tag="a" target="_blank">{{ voucher_info.name }}</router-link>
          </td>
          <td>{{ voucher_info.voucher_no }}</td>
          <td>{{ voucher_info.cheque_no }}</td>
          <td>{{ voucher_info.cheque_date }}</td>
          <td>{{ voucher_info.bank_desc }}</td>
          <td>{{ voucher_info.account_no }}</td>
          <td>{{ voucher_info.total_amount }}</td>
          <td>{{ voucher_info.code_pay_ep_type_desc }}</td>
          <td>{{ voucher_info.jvc_no }} ({{ voucher_info.jvc_date }})</td>
          <td>
            <span v-if="(voucher_info.cheque_no)">
                <a  @click.prevent="updateVoucherInfo(voucher_info);getJvcEpList(voucher_info.ses_id)" class="action-icon"
                   href="javascript:void(0);" title="Update Voucher Info">
                  <i class="mdi mdi-square-edit-outline editButton"></i>
                </a>
              </span>
            <span v-else>
              <a @click.prevent="addVoucherInfo(voucher_info);getJvcEpList(voucher_info.ses_id)" class="action-icon"
                  href="javascript:void(0);" title="Create Voucher Info">
                <i class="mdi mdi-plus-box addButton"></i>
              </a>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="loader" class="loader">Loading...</div>
      <h5 class="text-center text-secondary" v-if="voucher_infos.length === 0 || !flag">
        No Data Found
      </h5>
    </div>
    <voucher-info-modal
        :voucher_info="voucher_info"
        :btn_edit="btn_edit"
        :ses_id="this.ses_id"
        :jvc_lists="this.jvc_lists"
        @getVoucherInfos="getVoucherInfos"
        @resetForm="resetForm"
    ></voucher-info-modal>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

import VoucherInfoModal from "../../modals/VoucherInfoModal";
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
  page: {
    title: "Search Voucher",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, VoucherInfoModal},
  data() {
    return {
      title: "Search Voucher",
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Search',
          active: true,
        },
      ],
      voucher_infos: {},
      voucher_info: {},
      search_data: {
        voucher_no: '',
        ep_id: '',
        mouza_id: '',
        ep_type: '',
      },
      districts: [],
      all_upazilas: [],
      all_unions: [],
      all_mouzas: [],
      btn_edit: false,
      validation_errors: {},
      show: false,
      flag: false,
      loader: false,
      showSpinner: true,
      district_id: '',
      ses_id:'',
      jvc_lists:[],
    };
  },

  mounted() {
    this.search_data.district_id = this.$route.params.district_id;
    this.district_id = this.$route.params.district_id;
    this.getVoucherInfos();
    this.getCodes();
  },

  methods: {
    epIdWithPaymentStatus: epIdWithPaymentStatus,
    async getVoucherInfo(voucher_info) {
      this.voucher_info = {};
      this.btn_edit = true;
      await http.get("api/voucher-infos/" + voucher_info.id + "/edit").then(response => {
        if (!response.error) {
          this.voucher_info = response.data.voucher_info;
        }
      });
    },
    async getVoucherInfos() {
      this.flag = true
      this.loader = true
      await http.post("api/getVoucherInfo" , this.search_data)
          .then(response => {
            if (!response.error) {
              this.flag = true;
              this.loader = false
              this.voucher_infos = response.data.voucher_infos;
            }
          });
    },
    resetForm() {
      this.btn_edit = false;
      this.voucher_info = {};
    },
    getCodes() {
      http.get("api/voucher-info/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.districts = data.districts;
          this.all_upazilas = data.upazillas;
          this.all_unions = data.unions;
          this.all_mouzas = data.mouzas;

        }
      });
    },
    addVoucherInfo(voucher_info) {
      this.btn_edit = false;
      this.voucher_info = {};
      this.voucher_info.payment_voucher_id = voucher_info.payment_voucher_id;
      this.$root.$emit("bv::show::modal", "voucher-info-modal");
      //console.log(voucher_info.ses_id);
      this.ses_id = voucher_info.ses_id;
      this.$emit('ses_id',this.ses_id)
    },
    updateVoucherInfo(voucher_info) {
      this.btn_edit = true;
      this.voucher_info = {};
      http.get("api/voucher-infos/" + voucher_info.voucher_info_id + "/edit")
          .then(resource => {
            this.voucher_info = resource.data.voucher_info
          })
          .catch(error => console.log(error))
      this.$root.$emit("bv::show::modal", "voucher-info-modal");
    },
    getJvcEpList(ses_id) {
      http.get("api/jvc/list/ep/" + ses_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.jvc_lists = data.jvc_ep_lists;
        }
      });
    },
  },
  
  computed: {
    mouzas() {
      const district_id = Number.parseInt(this.search_data.district_id)
      const filterUpazila = (district_id) ? this.all_upazilas.filter(x => x.district_id === district_id) : null
      const filterUnion = []
      if (filterUpazila) {
        filterUpazila.forEach((value, index) => {
          const upazila_id = value.id
          const union = (upazila_id) ? this.all_unions.filter(x => x.upazila_id === upazila_id) : null
          filterUnion.push(union);
        });
      }
      const filterUnionResult = filterUnion.reduce((r, e) => (r.push(...e), r), [])
      const filterMouza = []
      if (filterUnionResult) {
        filterUnionResult.forEach((value, index) => {
          const union_id = value.id
          const mouza = (union_id) ? this.all_mouzas.filter(x => x.union_id === union_id) : null
          filterMouza.push(mouza);
        });
      }
      return filterMouza.reduce((r, e) => (r.push(...e), r), [])
    },
  },
};
</script>
